import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export function Field({ id, label, hint, error, children, testId }) {
  return (
    <div className="space-y-2">
      <div className="flex items-baseline justify-between">
        <label htmlFor={id} className="bz-caption text-slate-300">
          {label}
        </label>
        {hint}
      </div>
      {children}
      {error ? (
        <p data-testid={testId ? `${testId}-error` : undefined} className="text-xs text-red-300">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export function TextInput({ className = "", invalid = false, ...props }) {
  return <input className={`bz-input ${invalid ? "bz-input-error" : ""} ${className}`} {...props} />;
}

export function PasswordInput({ className = "", invalid = false, testId, ...props }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        type={visible ? "text" : "password"}
        className={`bz-input pr-11 ${invalid ? "bz-input-error" : ""} ${className}`}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        data-testid={testId ? `${testId}-toggle` : undefined}
        onClick={() => setVisible((v) => !v)}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1.5 text-slate-500 transition-colors hover:text-white"
        aria-label={visible ? "Hide password" : "Show password"}
      >
        {visible ? <EyeOff className="h-4 w-4" strokeWidth={1.75} /> : <Eye className="h-4 w-4" strokeWidth={1.75} />}
      </button>
    </div>
  );
}
